module.exports = __webpack_public_path__ + "static/media/success.0a8405f6.svg";